<template lang="pug">
  v-snackbar.Error(data-cy="error" v-model="showError" color="error" top :timeout="5000" multi-line)
    b Errore&nbsp;
    br
    span {{ errorMessage }}
    template(v-slot:action="{ attrs }")
      v-btn(@click="$emit('update:error', null)" v-bind="attrs" text) OK
</template>

<script>
export default {
  watch: {
    error: {
      immediate: true,
      handler(error) {
        if (error) this.showError = true;
      }
    }
  },
  computed: {
    errorMessage() {
      // if it has 'response' is (probably) an axios error
      if ("response" in this.error && this.error.response) {
        if (this.error.response.status === 401) {
          this.$auth.logout();
          this.$router.replace({ name: "auth.login" });
        }

        // server side/API error messages
        if (this.error.response.data && this.error.response.data.error) {
          return `${this.error.response.data.error}`;
        }

        if (this.error.response.data && this.error.response.data.message) {
          return `${this.error.response.data.message}`;
        }

        if (this.error.response.status === 500) {
          return "Qualcosa non va nei nostri sistemi. Riprova più tardi.";
        }
      }

      if (this.error.name === "ErrorMessage") {
        return this.error.message;
      }

      // just return the error if we don't know how to parse it
      return "Qualcosa non va nei nostri sistemi. Riprova più tardi.";
    }
  },
  props: {
    error: {
      default: null
    }
  },
  data() {
    return {
      showError: false
    };
  }
};
</script>
